export default __webpack_public_path__ + "media/images/manual/ic/01-98afb7767d8b7a6b2a3a94c834846ebf.png";